import { useEffect, useState } from "react";
import { fetchCarMakes } from "../../services/api";

import "./MakeSelection.scss";

import Buick from '../../assets/images/cars/make-logos/buick.png'
import Cadillac from '../../assets/images/cars/make-logos/cadillac.png'
import Chevrolet from '../../assets/images/cars/make-logos/chevrolet.png'
import GMC from '../../assets/images/cars/make-logos/gmc.png'
import Volkswagen from '../../assets/images/cars/make-logos/volkswagen.png'

const logoMap = {
    Buick,
    Cadillac,
    Chevrolet,
    GMC,
    Volkswagen
}

const MakeSelection = (props)=>{
    const [makeOptions, setMakeOptions] = useState([]);
    const [make, setMake] = useState(null);

    useEffect(() => {
        fetchCarMakes().then(makes => {
            setMakeOptions(makes);
        })
    }, []);

    useEffect(()=>{
        if(make){
            props.makeSelected(make);
        }
    },[make])

    const proceedToNext = (make)=>{
        setMake(make);
    }

    return (<>
        <div className="make-selection-wrapper">
            <div className="make-selection-header">Select Car Make</div>
            <ul className="make-selection-list">
                {
                    makeOptions.map(_=>{
                        return (
                            <li key={_.value} onClick={()=>{
                                proceedToNext(_.name);
                                window.dataLayer?.push({
                                    'event': 'Selected make'
                                })
                            }}>
                                <div className="logo-container">
                                    <img src={logoMap[_.name]}/>
                                </div>
                                <div>{_.name}</div>
                            </li>
                        )
                    })
                }
                
            </ul>
        </div>
    </>)
}

export default MakeSelection